import {
	IAssetLinkItem,
	IEmailLinkItem,
	IExternalLinkItem,
	IInternalLinkItem,
	IPhoneLinkItem,
} from '../../../../ui';
import { getLinkItemForEntry } from './getLinkItemForEntry';
import { ILinkEntry } from '../../../shared/api/contentful/types';
import { ISiteMap } from '../../../app/pages/domain/models/ISiteMap';

type ILinkItem =
	| IAssetLinkItem
	| IEmailLinkItem
	| IExternalLinkItem
	| IInternalLinkItem
	| IPhoneLinkItem;

export function getLinkItemsForEntries<T extends ILinkItem>(
	entries: ILinkEntry[] | undefined,
	siteMap: ISiteMap,
) {
	if (!entries || !entries.length) {
		return [];
	}

	const items: T[] = [];

	entries.forEach((entry, index) => {
		const item = getLinkItemForEntry(entry, index, siteMap);

		if (item) {
			items.push(item as T);
		}
	});

	return items;
}
